export class LanguageConstants {
  public static readonly BY_NAME = {
    ENGLISH: { ISO_CODE: 'en' },
  };
}
